'use strict';

const _=require('pulsar-utils/dist-es6/_');
const timespan=require('pulsar-utils/dist-es6/time/timespan');let

DataRetentionPeriod=class DataRetentionPeriod{
constructor(label,numWeeks=null){
this._label=label;
this._numWeeks=numWeeks;
this._value=_.exists(numWeeks)?timespan.fromDays(numWeeks*7).totalMilliseconds():null;
}

get numWeeks(){
return this._numWeeks;
}

get label(){
return this._label;
}

get value(){
return this._value;
}

valueOf(){
return this.value;
}

toJSON(){
return this.value;
}};


module.exports=DataRetentionPeriod;
module.exports.AvailableDataRetentionPeriods=[
new DataRetentionPeriod('Keep all data',null),
new DataRetentionPeriod('6 months',26),
new DataRetentionPeriod('1 year',52)];
//# sourceMappingURL=dataRetentionPeriod.js.map
